import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { Cookie } from "lucide-react";

const KEY = "sprz-consent";

export default function CookieBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(KEY)) {
        const t = setTimeout(() => setShow(true), 1600);
        return () => clearTimeout(t);
      }
    } catch (e) {
      /* storage non disponibile */
    }
  }, []);

  const decide = (val) => {
    try {
      localStorage.setItem(KEY, val);
    } catch (e) {
      /* ignora */
    }
    setShow(false);
  };

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 24 }}
          transition={{ duration: 0.35 }}
          data-testid="cookie-banner"
          className="fixed left-4 right-4 bottom-24 md:left-6 md:right-auto md:bottom-6 md:max-w-sm z-[70] rounded-2xl border border-white/10 bg-brand-surface/95 backdrop-blur-xl p-6 shadow-2xl shadow-black/60"
        >
          <div className="flex items-start gap-3">
            <Cookie size={18} className="text-brand-orange shrink-0 mt-0.5" />
            <p className="text-xs leading-relaxed text-white/70">
              Usiamo solo cookie tecnici per il funzionamento del sito. Nessun tracciamento
              di terze parti è attivo al momento.{" "}
              <Link to="/privacy" data-testid="cookie-privacy-link" className="text-brand-orange underline underline-offset-2">
                Scopri di più
              </Link>
            </p>
          </div>
          <div className="mt-4 flex gap-3">
            <button
              data-testid="cookie-accept"
              onClick={() => decide("accepted")}
              className="flex-1 rounded-full bg-brand-orange px-4 py-2.5 text-[11px] font-semibold uppercase tracking-[0.15em] text-brand-ink hover:bg-[#ff9433] transition-colors duration-200"
            >
              Accetta
            </button>
            <button
              data-testid="cookie-decline"
              onClick={() => decide("refused")}
              className="flex-1 rounded-full border border-white/15 px-4 py-2.5 text-[11px] font-semibold uppercase tracking-[0.15em] text-white/70 hover:border-white/40 transition-colors duration-200"
            >
              Rifiuta
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
